import * as XLSX from 'xlsx';
import htmlDocx from 'html-docx-js/dist/html-docx';

export function exportToExcel(filteredTenants) {
  const data = filteredTenants.map((t) => ({
    Company: t.companyName,
    TenantID: t.tenantId,
    Status: t.status,
    PaymentStatus: `${t.paymentStatus} (${t.unpaidMonth})`,
    Modules: t.modules.map((m) => `${m.name}: ${m.status}`).join(', '),
    LastAction: new Date(t.lastAction).toLocaleString()
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Tenants');
  XLSX.writeFile(workbook, 'TenantMatrix.xlsx');
}

export function exportToWord(filteredTenants) {
  const html = `
    <h2>Tenant Matrix Report</h2>
    <table border="1" cellpadding="5" cellspacing="0">
      <thead>
        <tr>
          <th>Company</th>
          <th>Tenant ID</th>
          <th>Status</th>
          <th>Payment</th>
          <th>Modules</th>
          <th>Last Action</th>
        </tr>
      </thead>
      <tbody>
        ${filteredTenants
          .map(
            (t) => `
          <tr>
            <td>${t.companyName}</td>
            <td>${t.tenantId}</td>
            <td>${t.status}</td>
            <td>${t.paymentStatus} (${t.unpaidMonth})</td>
            <td>${t.modules.map((m) => `${m.name}: ${m.status}`).join(', ')}</td>
            <td>${new Date(t.lastAction).toLocaleString()}</td>
          </tr>
        `
          )
          .join('')}
      </tbody>
    </table>
  `;

  const blob = htmlDocx.asBlob(html);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'TenantMatrix.docx';
  link.click();
}

export function printFiltered(filteredTenants) {
  const printable = `
    <html>
      <head><title>Tenant Matrix Print</title></head>
      <body>
        <h2>Tenant Matrix Report</h2>
        <ul>
          ${filteredTenants
            .map(
              (t) => `
            <li>
              <strong>${t.companyName}</strong> (ID: ${t.tenantId})<br/>
              Status: ${t.status}<br/>
              Payment: ${t.paymentStatus} (${t.unpaidMonth})<br/>
              Modules: ${t.modules.map((m) => `${m.name}: ${m.status}`).join(', ')}<br/>
              Last Action: ${new Date(t.lastAction).toLocaleString()}
            </li><br/>
          `
            )
            .join('')}
        </ul>
      </body>
    </html>
  `;

  const win = window.open('', '_blank');
  win.document.write(printable);
  win.document.close();
  win.print();
}
